import React from 'react';
import Modal from 'react-bootstrap/Modal';

export default function ImageModal(props) {
    return (
        <Modal
            {...props}
            dialogClassName="modal-40w"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <img src={props.src} alt="image_modal" style={{maxHeight:"-webkit-fill-available"}}/>
            <Modal.Footer>
                <button className="btn background-rojo-megatone btn-sm" onClick={props.onHide}>Cerrar</button>
            </Modal.Footer>
        </Modal>
    );
}